export default __webpack_public_path__ + "static/media/car-retro.9c006d86.svg";